/*
 * @Author: Alan
 * @Date: 2023-03-22 14:34:19
 * @LastEditors: Alan
 * @LastEditTime: 2023-03-28 11:44:16
 * @Description: 超过验证次数
 * @FilePath: \F1-M1-WEB-Code\components\OTP\ExceedVerify.js
 */
import React from "react";
import { Row, Col, Button, Modal } from "antd";

function ExceedVerify({
    offset,
    exceedVisible,
    closeExceedVerifyModal,
    times,
    headTitle,
    otpParam,
    onCancel,
    Description,
    btnInfo,
}) {
    // 彈窗，次數，標題，判斷OTP種類
    const IS_CRY_OTP = otpParam === 'cry-otp';

    return (
        <Modal
            style={offset ? { left: offset.left, top: offset.top } : {}}
            title={headTitle}
            className="modal-pubilc OTP-modal exceed-modal"
            visible={exceedVisible}
            closable={true}
            onCancel={onCancel}
            centered={true}
            width={400}
            footer={null}
            zIndex={1500}
            keyboard={false}
            maskClosable={false}
        >
            <Row>
                <Col span={24}>
                    {/* <h3 className="otp-modal-title">{headTitle}</h3> */}
                    <img
                        className="otp-warn"
                        src="/cn/img/icons/icon-warn.svg"
                        alt="icon-warn"
                    />
                    <h3 className="otp-modal-title">您已超过 {times} 次尝试</h3>
                    {Description}
                </Col>
            </Row>
            <div className={`btn-wrap otp-btn-wrap`}>
                {btnInfo === "revalidate" && otpParam === "login-otp" ? (
                    <Button
                        className="otpBtn readMore cry-otp-wrap"
                        onClick={() => {
                            global.PopUpLiveChat();
                            global.globalExit();
                        }}
                        block
                    >
                        联系在线客服
                    </Button>
                ) : otpParam === "login-otp" ||
                  otpParam === `memberProfile-otp` ||
                  IS_CRY_OTP ||
                  otpParam === `withdrawal-otp` ? (
                    <center>
                        {IS_CRY_OTP && <Button
							className="cry-opt-close-btn"
                            style={{ width: "48%", height: "40px" }}
							onClick={() => {
								closeExceedVerifyModal && closeExceedVerifyModal()
							}}
						>
							关闭
						</Button>}
                        <Button
                            className="otpBtn readMore"
                            style={{ width: IS_CRY_OTP ? '48%' : "100%", height: "40px" }}
                            onClick={() => global.PopUpLiveChat()}
                            block
                        >
                            联系在线客服
                        </Button>
                    </center>
                ) : (
                    <Button
                        className="otpBtn readMore cry-otp-wrap"
                        onClick={onCancel}
                        block
                    >
                        确认
                    </Button>
                )}
            </div>
        </Modal>
    );
}

export default ExceedVerify;
